import CvSearch from './CvSearch.vue';
const SEARCH_SIZES = ['sm', 'lg', 'xl'];
export { CvSearch, SEARCH_SIZES };
